import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Slider from "@irati/ui/src/Slider"
import {H2} from "@irati/ui/src/Typography"
import {TextButton} from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Col, Row} from "react-bootstrap"
import OnboardingCard from "./OnboardingCard"
import {RewardInformationSection, sliderSettings, isAdmin, isManager} from "./styled"

interface Props {
  canTopUp: boolean,
  completeStep: () => void
}

const OnboardingSection: FC<Props> = ({canTopUp, completeStep}) => (
  <>
    <H2 marginBottom={2}>
      <FormattedMessage id="wallet.reward.onboarding.section.title" />
    </H2>
    <RewardInformationSection>
      <Slider slidesToShow={3} settings={sliderSettings}>
        <OnboardingCard steps={canTopUp ? isAdmin.stepOne : isManager.stepOne} completeStep={completeStep} />
        <OnboardingCard steps={canTopUp ? isAdmin.stepTwo : isManager.stepTwo} completeStep={completeStep} />
        <OnboardingCard steps={canTopUp ? isAdmin.stepThree : isManager.stepThree} completeStep={completeStep} />
      </Slider>

      <Row>
        <Col xsHidden smHidden md={12}>
          <Flex justifyContent="flex-end" paddingBottom={4} paddingRight={4}>
            <TextButton onClick={completeStep}>
              <FormattedMessage id="wallet.reward.onboarding.section.doNotShowAgain.button" />
            </TextButton>
          </Flex>
        </Col>
      </Row>
    </RewardInformationSection>
  </>
)

export default OnboardingSection
